import axios from "axios";

const axiosInstance = axios.create({
  timeout: 15000, // ms
  headers: {
    common: {
      "content-type": "application/json",
    },
  },
});

axiosInstance.interceptors.request.use((config) => {
  config.headers["X-CSRF-Token"] = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");
  return config;
});

const refreshCsrfToken = (response) => {
  const token = response?.headers?.["x-csrf-token"];
  if (token) {
    document.querySelector('meta[name="csrf-token"]')?.setAttribute("content", token);
  }
  return response;
};

axiosInstance.interceptors.response.use(refreshCsrfToken, (error) => {
  refreshCsrfToken(error.response);
  return Promise.reject(error);
});

const rootURL = `${window.location.protocol}//${window.location.host}`;
axiosInstance.defaults.baseURL = `${rootURL}/api`;
// axios.defaults.withCredentials = true;

export default axiosInstance;
